module.exports = __webpack_public_path__ + "static/media/crocodile(24).598546b6.PNG";